global.year = 2020
global.nat = "France"

global.shapes2 = require('../Resources/Shapes/Area2.json')
global.shapes3 = require('../Resources/Shapes/Area3.json')
global.shapes4 = require('../Resources/Shapes/Area4.json')
global.shapes5 = require('../Resources/Shapes/Area5.json')

global.shapes2 = global.shapes2.features
global.shapes3 = global.shapes3.features
global.shapes4 = global.shapes4.features
global.shapes5 = global.shapes5.features

global.shapes = { Area2: global.shapes2, Area3: global.shapes3, Area4: global.shapes4, Area5: global.shapes5 }
global.center = [44.704861, -0]
